import IService from '../IService';

export default IService.extend({
  get: function () {
    const promise = $.Deferred();

    $.ajax({
      url: app.apiUrl('/api/v1/storyboardSchemas'),
      type: 'GET',
      contentType: 'application/json',
      error: function () {
        promise.reject();
      },

      success: function (response) {
        if (
          _.isObject(response) &&
          !_.isEmpty(response.predefinedAttributesModel)
        ) {
          promise.resolve(response.predefinedAttributesModel);
        } else {
          promise.reject(response);
        }
      },
    });

    return promise;
  },
});
